module.exports = __webpack_public_path__ + "c89542c5455e4b9a0b37c814a8d2b7ae.png";